import { SET_ADDGROUP } from '../actions';

const groupadd = (state = [], action) => {
  switch (action.type) {
	case SET_ADDGROUP:
      return [...action.value];  
    default: return state;
  }
}

export default groupadd;
